import {
  ScaffolderFormHeader,
  ScaffolderFormPaper,
} from '@internal/plugin-scaffolder-common-field-react';
import React from 'react';

import { Box } from '@material-ui/core';

import { ClusterPicker } from '../components/ClusterPicker';
import { ClusterConfiguration, Cluster, DEFAULT_CLUSTER } from '../types';

interface ApplicationClusterSectionProps {
  value: ClusterConfiguration | null;
  availableClusters: Cluster[];
  onChange: (value: ClusterConfiguration | null) => void;
  errors: string[];
}

const ApplicationClusterSectionInner = ({
  value,
  availableClusters,
  onChange,
  errors,
}: ApplicationClusterSectionProps) => {
  return (
    <Box>
      <ScaffolderFormPaper>
        <ScaffolderFormHeader
          title="Cluster"
          description="Select the cluster and namespace for this Application."
          divider
        />
        <ClusterPicker
          value={value ?? DEFAULT_CLUSTER}
          clusters={availableClusters}
          onChange={onChange}
          errors={errors}
        />
      </ScaffolderFormPaper>
    </Box>
  );
};

export const ApplicationClusterSection = React.memo(
  ApplicationClusterSectionInner,
);
